import { db } from '@/db';
import { poll } from '@/db/schema';
import { PollWithOptions } from '@/lib/server-functions/helper-functions/fetch-polls';
import { createServerFn } from '@tanstack/react-start';
import { and, eq } from 'drizzle-orm';
import z from 'zod';

const getPollsSchema = z.object({
  shortId: z.string(),
  slug: z.string(),
});

export const getPollMetadata = createServerFn({ method: 'GET' })
  .inputValidator(getPollsSchema)
  .handler(async (ctx): Promise<Pick<PollWithOptions, 'question'> | null> => {
    const { shortId, slug } = ctx.data;

    const [firstPoll] = await db
      .select({
        question: poll.question,
      })
      .from(poll)
      .where(and(eq(poll.shortId, shortId), eq(poll.slug, slug)))
      .limit(1);

    return firstPoll;
  });
